import PropTypes from 'prop-types';

export default {
    allLocales: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string,
            contentfulLocale: PropTypes.string,
        }),
    ),
    documentLinksArray: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            route: PropTypes.string,
            node_locale: PropTypes.string,
        }).isRequired,
    ),
};
